<h2 class="heading--2" i18n="@@latestMealPlanHeading">Latest meal plan</h2>

<cdx-carousel2
	[name]="carouselName"
	[itemCount]="latestMealPlan.mealPlan.meals.length"
	[columns]="columns"
>
	<cdx-carousel2-item
		*ngFor="let stamp of latestMealPlan.mealPlan.meals; let i = index"
		[impressionTrackingEnabled]="true"
		[impressionArgs]="getRecipeImpressionArgs(stamp.recipe, i)"
	>
		<recipe-stamp
			[stamp]="stamp"
			[stampType]="stampType"
			[useCustomActions]="true"
			(save)="handleSaveOrUnsaveRecipe(stamp)"
		>
			<ng-container customActions>
				<a cdxButton fillStyle="outline" [fullWidth]="true" [href]="getRecipePath(stamp)"
				   i18n="@@latestMealPlanViewRecipe" data-cy="viewRecipe">View recipe</a>
			</ng-container>
		</recipe-stamp>
	</cdx-carousel2-item>
</cdx-carousel2>

<div class="details">
	<div class="fulfilment" *ngIf="isFulfilmentDataFixed">
		<ng-container *ngIf="latestMealPlan.fulfilmentMethod === 'pickup'; else delivery">
			<cdx-svg-icon name="shopping-bags" fill="gray"></cdx-svg-icon>
			<p i18n="@@latestMealPlanPickup">Pick up at Countdown {{ latestMealPlan.fulfilmentLocation }}
				on {{ latestMealPlan.mealPlan.fulfilmentDate }}</p>
		</ng-container>
		<ng-template #delivery>
			<cdx-svg-icon name="truck-delivery" fill="gray"></cdx-svg-icon>
			<p i18n="@@latestMealPlanDelivery">Deliver to {{ latestMealPlan.fulfilmentLocation }}
				on {{ latestMealPlan.mealPlan.fulfilmentDate }}</p>
		</ng-template>
	</div>

	<div class="actions">
		<button cdxButton startSlotSize="small" [startSlotActive]="true" fillStyle="flat" [inline]="true"
				[disabled]="viewInvoiceDisabled" (click)="viewInvoice.emit(latestMealPlan.mealPlan.orderId)"
				i18n="@@latestMealPlanViewInvoice" data-cy="viewInvoiceButton">
			<cdx-svg-icon name="shopping-list" start fill="green"></cdx-svg-icon>
			View invoice
		</button>

		<cdx-popup
			popupActiveClass="popupOpen"
			[hasCloseBtn]="true"
			popupId="printMessagePopup"
			scrollStrategy="close"
			popupPosition="end"
		>
			<button class="printButton" cdxButton startSlotSize="small" [startSlotActive]="true" endSlotSize="small"
					[endSlotActive]="true" fillStyle="flat" [inline]="true" (click)="displayPrintableMealPlan()"
					i18n="@@latestMealPlanPrintMealPlan">
				<cdx-svg-icon name="print" size="small" start fill="green"></cdx-svg-icon>
				Print meal plan
				<div class="print-popup-container" cdxPopupTarget>
					<cdx-svg-icon name="hint" size="small" end fill="dark"></cdx-svg-icon>
				</div>
			</button>

			<p cardContent i18n="@@latestMealPlanPrintDescription">This will include your menu for the week as well as
				each recipe.</p>
		</cdx-popup>
	</div>
</div>

<recipe-print-meal-plan-recipes *ngIf="showPrintableMealPlan" [recipeIdList]="recipeIdList"
								(readyToPrint)="printMealPlanRecipes()"></recipe-print-meal-plan-recipes>
